import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiwrapperService } from 'src/app/services/apiwrapper.service';

@Injectable({
  providedIn: 'root'
})
export class ProjectTeamDataServiceService {

  constructor(private api: ApiwrapperService) { }

  createProjectTeam(projectBody: any): Observable<any> {
    return this.api.createProjectTeam(projectBody);
  }

  startProjectTeam(projectUuid: string): Observable<any> {
    return this.api.startProjectTeam(projectUuid);
  }

  addMembersToProjectTeam(membersBody: any, projectUuid: string): Observable<any> {
    return this.api.addProjectTeamMembers(membersBody, projectUuid);
  }

  getPhases(projectTypeUuid: string): Observable<any> {
    return this.api.getProjectTeamPhases(projectTypeUuid);
  }

  getFrequencies(): Observable<any> {
    return this.api.getProjectFrequencies();
  }

  getPhaseSummaryQuestions(phaseUuid: string): Observable<any> {
    return this.api.getProjectTeamPhaseSummaryQuestions(phaseUuid);
  }

  searchUser(searchValue: string): Observable<any> {
    return this.api.getSearchWorkspaceMember(searchValue);
  }

  getProjectTypes(): Observable<any> {
    return this.api.getProjectTeamTypes();
  }

  getAllWorkspaceUsers(pageNumber: number): Observable<any> {
    return this.api.getWorkspacesUserWithPagination(pageNumber);
  }
}
